export default {
  en: {
    breadcrumbTitle: "Adversaries",
    title: "Adversary",
    createTitle: "Create an Adversary",
    updateTitle: "Edit",
    viewTitle: "View",
    createButton: "Create",
    emptyList: "No Adversaries found",
    addAllButton: "Add Abilities",
    returnButton: "Return and Add more",
    createDescription:
      "Adversary profiles are collections of ATTA&CK TTPs, designed to create specific effects on a host or network. Profiles can be used for offensive or defensive use cases.",
    createLabelNameField: "Adversary Name",
    createPlaceholderName:
      "Insert the name of the adversary you want to create",
    createLabelDescription: "Adversary Description",
    createPlaceholderDescription:
      "Describe the adversary function and objective so you can easily identify it when looking for it.",
    configTitle: "Find the abilities you want to add in the adversary",
    configDescription:
      "You can find what you are looking for and add multiple abilities at the same time to help you reach the effect you want on this adversary",
    configSelectedAbilitiesTitle: "Selected abilities",
    configRemoveAllTitle: "Remove all",
    configSelectedAbilitiesSubtitle: "No abilities were selected yet",
    configSelectedAbilitiesText:
      "You can begin to fill your ability stack by use the search above and find wich one would help you to achiev your objectives",
    configListAbilitiesSubtitle: "You can begin by using the search above",
    configListAbilitiesText:
      "Make sure your search is correct so we can help with results of it!",
    selectAdversary: "- Select a adversary -",
    threatLevel: "Threat Level:",
    description: "Description:",
    searchResults:
      "Your search resulted in <strong>{in}</strong> out of <strong>{outOf}</strong> adversaries",
    searchResultsTotal:
      "Your search resulted in <strong>{outOf}</strong> adversaries",
    editName: "Edit name and description",
    objective: "Objective",
    changeObjective: "Change Objetive",
    addMoreAbilities: "Add more Abilities",
    findAbilities: "Find an ability",
    searchNotFoundTitle: "Sorry, we could not find anything",
    searchNotFoundDescription:
      "Make sure your search is correct so we can help with results of it!",
    addMoreFacts: "Add more facts",
    addMoreRules: "Add more rules",
    score: {
      undefined: "Undefined",
      low: "Low",
      medium: "Medium",
      high: "High",
      critical: "Critical",
      finalboss: "Final Boss"
    },
    pattern: "This adversary cannot be edited",
    validate: {
      suggestion:
        "You can either include before it some ability to complement it or include a Fact manually in Step 5 of this form (Facts)."
    },
    deleteAdversaryTitle: "Delete Adversary?",
    deleteAdversaryDescription:
      "Are you sure that you want to delete this adversary?"
  },
  pt: {
    breadcrumbTitle: "Adversários",
    title: "Adversário",
    createTitle: "Criar um Adversário",
    updateTitle: "Editar",
    viewTitle: "Visualizar",
    createButton: "Criar",
    emptyList: "Nenhum Adversário encontrado",
    addAllButton: "Adicionar Habilidades",
    returnButton: "Retornar e Adicionar mais",
    createDescription:
      "Os perfis adversos são coleções de ATTA&CK TTPs, projetados para criar efeitos específicos em um host ou rede. Os perfis podem ser usados para casos de uso ofensivo ou defensivo.",
    createLabelNameField: "Nome do Adversário",
    createPlaceholderName: "Insira o nome do adversário que você deseja criar",
    createLabelDescription: "Descrição do Adversário",
    createPlaceholderDescription:
      "Descreva a função e o objetivo do adversário para que você possa identificá-lo facilmente ao procurá-lo.",
    configTitle:
      "Encontre as habilidades que você deseja acrescentar ao adversário",
    configDescription:
      "Você pode encontrar o que está procurando e adicionar múltiplas habilidades ao mesmo tempo para ajudá-lo a alcançar o efeito que você quer sobre este adversário",
    configSelectedAbilitiesTitle: "Habilidades selecionadas",
    configRemoveAllTitle: "Remover tudo",
    configSelectedAbilitiesSubtitle: "Nenhuma habilidade foi selecionada ainda",
    configSelectedAbilitiesText:
      "Você pode começar a preencher sua pilha de habilidades usando a busca acima e encontrar o que o ajudaria a atingir seus objetivos",
    configListAbilitiesSubtitle: "Você pode começar usando a busca acima",
    configListAbilitiesText:
      "Certifique-se de que sua busca está correta para que possamos ajudar com os resultados dela!",
    selectAdversary: "- Selecione um adversário -",
    threatLevel: "Nível de Ameaça:",
    description: "Descrição:",
    searchResults:
      "Sua busca resultou em <strong>{in}</strong> de <strong>{outOf}</strong> adversários",
    searchResultsTotal:
      "Sua busca resultou em <strong>{outOf}</strong> adversários",
    editName: "Editar nome e descrição",
    objective: "Objetivo",
    changeObjective: "Alterar Objetivo",
    addMoreAbilities: "Adicionar mais Habilidades",
    findAbilities: "Encontre uma Habilidade",
    searchNotFoundTitle: "Desculpe, não encontramos nada",
    searchNotFoundDescription:
      "Certifique-se de que sua busca está correta para que possamos ajudar com os resultados dela!",
    addMoreFacts: "Adicionar mais facts",
    addMoreRules: "Adicionar mais rules",
    score: {
      undefined: "Indefinido",
      low: "Baixo",
      medium: "Médio",
      high: "Alto",
      critical: "Crítico",
      finalboss: "Chefão Final"
    },
    pattern: "Este adversário não pode ser editado",
    validate: {
      suggestion:
        "Você pode incluir antes dela alguma habilidade para complementá-la ou incluir um Fact manualmente no Step 5 deste formulário (Facts)."
    },
    deleteAdversaryTitle: "Excluir Adversário?",
    deleteAdversaryDescription:
      "Tem certeza que deseja excluir esse adversário?"
  },
  es: {
    breadcrumbTitle: "Adversarios",
    title: "Adversario",
    createTitle: "Crear un adversario",
    updateTitle: "Editar",
    viewTitle: "Ver",
    createButton: "Crear",
    emptyList: "No se encontraron adversarios",
    addAllButton: "Añadir Habilidades",
    returnButton: "Volver y añadir más",
    createDescription:
      "Los perfiles de adversarios son colecciones de TTPs ATTA&CK, diseñados para crear efectos específicos en un host o red. Los perfiles pueden utilizarse para casos de uso ofensivo o defensivo.",
    createLabelNameField: "Nombre del adversario",
    createPlaceholderName:
      "Introduzca el nombre del adversario que desea crear",
    createLabelDescription: "Descripción del adversario",
    createPlaceholderDescription:
      "Describe la función y el objetivo del adversario para que puedas identificarlo fácilmente cuando lo busques.",
    configTitle:
      "Encuentra las habilidades que quieres añadir en el adversario",
    configDescription:
      "Puedes encontrar lo que buscas y añadir varias habilidades al mismo tiempo para ayudarte a conseguir el efecto que deseas en este adversario",
    configSelectedAbilitiesTitle: "Habilidades seleccionadas",
    configRemoveAllTitle: "Eliminar todas",
    configSelectedAbilitiesSubtitle:
      "Todavía no se ha seleccionado ninguna habilidad",
    configSelectedAbilitiesText:
      "Puedes empezar a llenar tu pila de habilidades usando la búsqueda de arriba y encontrar cuál te ayudaría a conseguir tus objetivos",
    configListAbilitiesSubtitle: "Puedes empezar usando la búsqueda de arriba",
    configListAbilitiesText:
      "Asegúrate de que tu búsqueda es correcta para que podamos ayudarte con los resultados de la misma",
    selectAdversary: "- Selecciona un adversario -",
    threatLevel: "Nivel de amenaza:",
    description: "Descripción:",
    searchResults:
      "Su búsqueda ha resultado en <strong>{in}</strong> de <strong>{outOf}</strong> adversarios",
    searchResultsTotal:
      "Su búsqueda ha dado como resultado <strong>{outOf}</strong> adversarios",
    editName: "Editar nombre y descripción",
    objective: "Objetivo",
    changeObjective: "Cambiar el Objetivo",
    addMoreAbilities: "Añadir más habilidades",
    findAbilities: "Encontrar una habilidad",
    searchNotFoundTitle: "Lo sentimos, no hemos podido encontrar nada",
    searchNotFoundDescription:
      "Asegúrese de que su búsqueda es correcta para que podamos ayudarle con los resultados de la misma.",
    addMoreFacts: "Añadir más facts",
    addMoreRules: "Añadir más reglas",
    score: {
      undefined: "Indefinido",
      low: "Bajo",
      medium: "Medio",
      high: "Alto",
      critical: "Crítico",
      finalboss: "Jefe Final"
    },
    pattern: "Este adversario no puede editar",
    validate: {
      suggestion:
        "Puede incluir antes alguna habilidad que la complemente o incluir un Fact manualmente en el Paso 5 de este formulario (Facts)."
    },
    deleteAdversaryTitle: "¿Eliminar al adversario?",
    deleteAdversaryDescription:
      "¿Estás seguro de que quieres eliminar a este adversario?"
  }
}
